if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.timeout;
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.quantityInput = this.querySelector('.quantity__input');
      this.quantityInput.addEventListener('error', this.validateQuantity.bind(this));
      this.addToCartButtons = this.querySelectorAll('[data-add-to-cart]');
      this.onWindowResize = this.debounce(() => this.handleWindowResize.bind(this));

      this.addToCartSection = document.querySelector('.product-single__meta');
      this.addToCartContent = this.addToCartSection.querySelector('.product__meta-grid');
      this.productSelectors = this.addToCartContent.querySelector('.product__meta-grid-item--selectors');
      this.productMetaPrice = this.addToCartContent.querySelector('[data-product-meta-price]');
      this.lowStockNotification = this.addToCartContent.querySelector('[data-left-quantity]');
      this.controlsGroupSubmitTrigger = this.querySelector('#data-controls-group-submit-trigger');
      this.controlsGroupSubmit = this.querySelector('[data-controls-group-submit]');
      this.goToCartButtons = this.querySelectorAll('[data-go-to-cart]');

      this.addToCartSection.querySelector('.product__meta-grid-close-button').addEventListener('click', () => {
        this.hideColorsAndSizes();
      });
      this.onBodyClick = this.handleBodyClick.bind(this);

      this.dynamicCheckoutWrap = this.querySelector('.product-form__dynamic-buttons');
      this.dynamicCheckoutWrap.addEventListener('click', (evt) => {
        evt.preventDefault();
        if (this.dynamicCheckoutWrap.classList.contains('product-form__dynamic-buttons--disable')) {
          let error = this.getValidationError();
          this.handleErrorMessage(error);
        } else {
          this.dynamicCheckoutWrap.classList.add('product-form__dynamic-buttons--loading');
          const shopifyButton = evt.target;
          shopifyButton.innerHTML = `<span class="product-form-spinner" data-loader>
            <div class="spinner">
              <div class="bounce1"></div>
              <div class="bounce2"></div>
              <div class="bounce3"></div>
            </div>
          </span>`
          shopifyButton.dataset.loading = true;
        }
      });

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('resize', this.onWindowResize);
      this.initBreakpoints();
    }

    initBreakpoints() {
      const self = this;

      enquire.register('screen and (max-width: 1024px)', {
        match: () => {
          self.addToCartContent.addEventListener('transitionrun', function(evt) {
            const isCartContentAndBackgroundProperty = self.addToCartContent.classList.contains(evt.target.className) && evt.propertyName === 'bottom';

            if (isCartContentAndBackgroundProperty && !self.addToCartSection.classList.contains('active-mobile-cart')) {
              self.productSelectors.classList.add('animation--delay');
            }
          });

          self.addToCartContent.addEventListener('transitionstart', function(evt) {
            if (self.addToCartContent.classList.contains(evt.target.className) && evt.propertyName === 'bottom') {
              self.addToCartContent.style.position = 'fixed';
            }
          });

          self.addToCartContent.addEventListener('transitionend', function(evt) {
            if (self.addToCartContent.classList.contains(evt.target.className) && !self.addToCartSection.classList.contains('active-mobile-cart')) {
              if (evt.propertyName === 'bottom') {
                self.addToCartContent.removeAttribute( 'style' );
                self.productSelectors.classList.remove('animation--delay');
              }
            }
          });

          self.controlsGroupSubmit.addEventListener('animationend', function(evt) {
            const groupSubmitHaveAnimateClass = self.controlsGroupSubmit.classList.contains('animate-fade-left-out');
            if (evt.animationName === 'fade-out' && groupSubmitHaveAnimateClass) {
              self.controlsGroupSubmit.classList.remove('animate-fade-left-out');
            }
          });

          window.addEventListener('scroll', self.onScrollHandler, false);
          self.bpSmall = true;
        },
        unmatch: () => {
          window.removeEventListener('scroll', self.onScrollHandler, false);
          self.bpSmall = false;
        }
      });
    }

    onScroll() {
      const elemTop = this.controlsGroupSubmitTrigger.getBoundingClientRect().top;
      const controlsIsFixed = this.controlsGroupSubmit.classList.contains('fix-controls-group--submit');

      if (controlsIsFixed && elemTop > -56) {
        requestAnimationFrame(this.resetAddToCartButton.bind(this));
      } else if (!controlsIsFixed && elemTop < -56 ) {
        requestAnimationFrame(this.stickyAddToCartButton.bind(this));
      }
    }

    resetAddToCartButton() {
      this.controlsGroupSubmit.classList.add('animate-fade-left-out');
      this.controlsGroupSubmit.classList.remove('fix-controls-group--submit');
    }

    stickyAddToCartButton() {
      this.controlsGroupSubmit.classList.add('fix-controls-group--submit');
    }

    handleWindowResize() {
      const addToCartHeight = this.addToCartSection.offsetHeight;
      this.addToCartSection.offsetHeight.style.minHeight = `${addToCartHeight}px`;
    }

    debounce(func, timeout = 300) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
      };
    }

    validateQuantity(evt) {
      evt.preventDefault();
      const quantityLimit = this.quantityInput.getAttribute('max');
      const lowStockIsInactive = !this.lowStockNotification || this.lowStockNotification.textContent === '';

      if (lowStockIsInactive) {
        this.handleErrorMessage(window.variantStrings.lowStockError.replace(
          '[quantity]',
          quantityLimit
        ));
      }
    }

    getValidationError() {
      let error = '';
      let fieldsetsRadios = Array.from(this.productSelectors.querySelectorAll('fieldset')) || [];
      let fieldsets = Array.from(this.productSelectors.querySelectorAll('select')) || [];

      if (fieldsets.length) {
        fieldsets = fieldsets.map((fieldset) => {
          const selectedIndex = fieldset.selectedIndex;
          const nameRegex = fieldset.name.match(/\[(.*?)\]/) || [];

          if (selectedIndex) {
            return {
              name: nameRegex[1],
              value: fieldset.value
            };
          } else {
            return {
              name: nameRegex[1]
            }
          }
        });
      }

      if (fieldsetsRadios.length) {
        fieldsetsRadios = fieldsetsRadios.map((fieldset) => {
          const inputChecked = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
          const name = fieldset.querySelector('input').name;

          if (inputChecked) {
            return {
              name: inputChecked.name,
              value: inputChecked.value
            };
          } else {
            return {
              name: name
            }
          }
        });
      }

      const options = fieldsetsRadios.concat(fieldsets);
      options.forEach((option) => {
        if (!option.value && option.name) {
          error = `${window.variantStrings.variantValidError} ${option.name.toLocaleLowerCase()}`;
        }
      });

      return error;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      // validation
      let error = this.getValidationError();

      if (error) {
        if (this.bpSmall && !this.addToCartSection.classList.contains('active-mobile-cart')) {
          if (this.controlsGroupSubmit.classList.contains('fix-controls-group--submit')) {
            this.showColorsAndSizes();
          } else {
            this.handleErrorMessage(error);
          }
        } else {
          this.handleErrorMessage(error);
        }
        return;
      }

      this.handleButtonLoadingState(true);

      const config = fetchConfig('javascript');
      const formObject = JSON.parse(serializeForm(this.form));
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...formObject,
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            let errorMsg = response.description;
            const r = /All \d+/;
            const matchItemsLeft = errorMsg.match(r);
            const r2 = /You can't add more /i;
            const matchCantAdd = errorMsg.match(r2);

            if (matchItemsLeft && matchItemsLeft.length) {
              const itemsLeft = matchItemsLeft[0].replace('All ', '');
              errorMsg = `We only have ${itemsLeft} and they’re already in your cart!`;
              if (itemsLeft === '1') {
                errorMsg = `We only have ${itemsLeft} and it's already in your cart!`;
              }
            }

            if (matchCantAdd && matchCantAdd.length) {
              errorMsg = `You can't add more of this item to your cart.`;
            }

            this.handleButtonLoadingState(false);
            this.handleErrorMessage(errorMsg);
            return;
          }
          if (this.bpSmall) {
            this.renderBubbleCart(response);
            this.showGoToCartButton();

            if (this.addToCartSection.classList.contains('active-mobile-cart')) {
              setTimeout(() => {
                this.hideColorsAndSizes();
              }, 5000);
            }
          } else {
            this.cartNotification.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (!this.bpSmall) {
            this.handleButtonLoadingState(false);
          }
        });
    }

    renderBubbleCart(response) {
      const productCartIcon = document.getElementById('cart-icon-bubble--product');
      if (productCartIcon) {
        const html = response.sections['cart-icon-bubble'];
        const sourceCartIcon = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('.shopify-section');
        productCartIcon.innerHTML = sourceCartIcon.innerHTML;
      }
    }

    handleBodyClick(evt) {
      const target = evt.target;
      if (target != this.addToCartSection && !target.closest('.product-single__meta')) {
        this.hideColorsAndSizes();
      }

      if (target.id == 'ShowPickupAvailabilityDrawer') {
        this.hideColorsAndSizes(true);
      }
    }

    showColorsAndSizes() {
      this.addToCartSection.style.minHeight = `${this.addToCartSection.offsetHeight}px`;
      this.addToCartSection.classList.add('active-mobile-cart');
      this.controlsGroupSubmit.classList.remove('fix-controls-group--submit');
      document.body.addEventListener('click', this.onBodyClick);
      const scrollY = window.scrollY;
      document.body.classList.add('overflow-hidden');
      document.body.style.top = `-${scrollY}px`;
      trapFocus(this.addToCartSection);

      this.addToCartSection.addEventListener('swipeDown', () => {
        this.hideColorsAndSizes();
      }, false);
    }

    hideColorsAndSizes(openAvailabilityDrawer) {
      this.addToCartSection.classList.remove('active-mobile-cart');
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.controlsGroupSubmit.classList.add('fix-controls-group--submit');
      }, 400);
      document.body.removeEventListener('click', this.onBodyClick);
      if(!openAvailabilityDrawer) {
        const scrollY = document.body.style.top;
        document.body.classList.remove('overflow-hidden');
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
      removeTrapFocus(this.addToCartSection);
    }

    showGoToCartButton() {
      this.goToCartButtons.forEach((goToCartButton) => {
        goToCartButton.classList.add('product-form__open-cart--fadein');
      });

      setTimeout(() => {
        this.handleButtonLoadingState(false);
      }, 500);

      setTimeout(() => {
        this.goToCartButtons.forEach((goToCartButton) => {
          goToCartButton.classList.remove('product-form__open-cart--fadein');
        });
      }, 5000);
    }

    handleButtonLoadingState(isLoading) {
      if (isLoading) {
        this.addToCartButtons.forEach((addToCart) => {
          addToCart.disabled = true;
          addToCart.setAttribute('aria-disabled', true);
          addToCart.classList.add('product-form__cart-submit--loading');
        });
      } else {
        this.addToCartButtons.forEach((addToCart) => {
          addToCart.disabled = false;
          addToCart.removeAttribute('aria-disabled');
          addToCart.classList.remove('product-form__cart-submit--loading');
        });
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorButtonFixed = this.errorButtonFixed || this.querySelector('.product-form__error-message-wrapper.mobile--error');
      this.errorMessageFixed = this.errorMessageFixed || this.errorButtonFixed.querySelector('.product-form__error-message');

      if (errorMessage) {
        this.errorMessageWrapper.classList.remove('hidden');
        this.errorButtonFixed.classList.remove('mobile--error--hidden');
        this.errorMessage.textContent = errorMessage;
        this.errorMessageFixed.textContent = errorMessage;
        if (this.lowStockNotification) {
          this.lowStockNotification.textContent = '';
        }
      } else {
        this.errorMessageWrapper.classList.add('hidden');
        this.errorButtonFixed.classList.add('mobile--error--hidden');
      }
    }
  });
}
